"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const adEvents_1 = require("../../../types/sports/rugbyLeague/adEvents");
exports.rugbyLeagueAdEvents = [
    adEvents_1.RugbyLeagueAdAllocationEvent.try,
    adEvents_1.RugbyLeagueAdAllocationEvent.dropGoal,
    adEvents_1.RugbyLeagueAdAllocationEvent.conversion,
    adEvents_1.RugbyLeagueAdAllocationEvent.penaltyGoal
];
//# sourceMappingURL=adEvents.js.map